export const _setAutoAssets = (state, action) => {
  state.autoAssets = [...state.autoAssets, action.payload];
};
